import PropTypes from 'prop-types';
import React from 'react';

import InfiniteScroll from 'react-infinite-scroll-component';
import GridItemCard from './GridItemCard';

const GridView = ({
  folder,
  currentUser,
  team,
  selectedFolderedItems,
  togglefolderedItemSelected,
  fetchCalendarEventAttachment,
  fetchFolderedItemsForFolder,
  searchTerm,
  sortBy,
  onNavigateToFolder,
  onContextMenu
}) => {
  if (!folder.foldered_items || folder.foldered_items.length === 0) {
    return null;
  }

  const sorted = [...folder.foldered_items].sort((a, b) => {
    if (a.item.is_folder && !b.item.is_folder) return -1;
    if (!a.item.is_folder && b.item.is_folder) return 1;
    return a.item.human_file_name.localeCompare(b.item.human_file_name);
  });

  return (
    <InfiniteScroll dataLength={folder.foldered_items.length}
                    next={
                      () => {
                        fetchFolderedItemsForFolder(team, folder, searchTerm, sortBy);
                      }
                    }
                    style={{"overflow": "visible"}}
                    hasMore={
                      folder.lastRequestData
                        && folder.foldered_items.length < folder.lastRequestData.total_entries
                    }>
      <div className="asset-grid-view">
        {sorted.map((foldered) => (
          <GridItemCard
            key={foldered.id}
            foldered={foldered}
            currentUser={currentUser}
            team={team}
            selectedFolderedItems={selectedFolderedItems}
            togglefolderedItemSelected={togglefolderedItemSelected}
            fetchCalendarEventAttachment={fetchCalendarEventAttachment}
            onNavigateToFolder={onNavigateToFolder}
            onContextMenu={onContextMenu}
          />
        ))}
      </div>
      {folder.isLoadingPaginatedData ? (
        <div className="text-center py-3">
          <div className="css-spinner css-spinner--lg"></div>
        </div>
      ) : null}
    </InfiniteScroll>
  );
};

GridView.propTypes = {
  folder: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  selectedFolderedItems: PropTypes.array.isRequired,
  togglefolderedItemSelected: PropTypes.func.isRequired,
  fetchCalendarEventAttachment: PropTypes.func.isRequired,
  fetchFolderedItemsForFolder: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  sortBy: PropTypes.object,
  onNavigateToFolder: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func
};

export default GridView;
